module.exports = __webpack_public_path__ + "img/personaje-0.7f9019dd.png";